import { Reveal } from "@/components/Reveal";

const FEATURED = {
  src: "/renders/props-kit.png",
  name: "The Kit",
  note: "Your recovery shelf, in one mocha case — amber bottles, daily blends, and a notes journal",
};

const OBJECTS = [
  { src: "/renders/props-bottle.png", name: "The Bottle", note: "Matte mocha steel" },
  { src: "/renders/props-apparel.png", name: "The Stack", note: "Cream & taupe sportswear" },
  { src: "/renders/props-tote.png", name: "The Tote", note: "Canvas carry-all" },
  { src: "/renders/props-cap.png", name: "The Cap", note: "Mocha, cream stitch" },
];

export const BrandWorld = () => (
  <section data-testid="brand-world" className="max-w-7xl mx-auto px-6 md:px-10 pb-28 md:pb-40">
    <Reveal>
      <p className="text-xs font-medium tracking-[0.25em] uppercase text-[#2C241E]/50 mb-4">
        04 / The World
      </p>
      <h2
        data-testid="brand-world-headline"
        className="font-display text-4xl md:text-6xl tracking-tighter text-[#2C241E] mb-6"
      >
        Objects From Our World.
      </h2>
      <p className="text-base md:text-lg leading-relaxed text-[#2C241E]/65 max-w-2xl mb-14">
        LIGATEN is bigger than one product. A first look at the objects carrying the name —
        bottles, sportswear, and the everyday pieces in between.
      </p>
    </Reveal>
    <div className="grid grid-cols-2 lg:grid-cols-6 gap-4 md:gap-5">
      <Reveal className="col-span-2" delay={0}>
        <div data-testid="world-object-kit" className="group">
          <div className="rounded-2xl overflow-hidden h-64 md:h-[380px] bg-[#E5DFD5] border border-[#2C241E]/10">
            <img
              src={FEATURED.src}
              alt={`LIGATEN ${FEATURED.name} — ${FEATURED.note}`}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
          </div>
          <p className="mt-3 font-display text-lg md:text-xl text-[#2C241E]">
            {FEATURED.name}
            <span className="ml-2 text-[10px] font-sans font-medium tracking-[0.2em] uppercase text-[#A07856] align-middle">
              New Concept
            </span>
          </p>
          <p className="text-xs text-[#2C241E]/50 max-w-md">{FEATURED.note}</p>
        </div>
      </Reveal>
      {OBJECTS.map((o, i) => (
        <Reveal key={o.name} delay={(i + 1) * 0.07}>
          <div
            data-testid={`world-object-${o.name.toLowerCase().replace("the ", "")}`}
            className="group"
          >
            <div className="rounded-2xl overflow-hidden h-64 md:h-[380px] bg-[#E5DFD5] border border-[#2C241E]/10">
              <img
                src={o.src}
                alt={`LIGATEN ${o.name} — ${o.note}`}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <p className="mt-3 font-display text-lg md:text-xl text-[#2C241E]">{o.name}</p>
            <p className="text-xs text-[#2C241E]/50">{o.note}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
